// extracted by mini-css-extract-plugin
module.exports = {"page":"PlayerList_page__94c1K","mainTable":"PlayerList_mainTable__2ePW_","subBtnStyle":"PlayerList_subBtnStyle__1ExVQ","inputStyle":"PlayerList_inputStyle__NgyXQ"};